import { Environment } from './environment.interface';

export const environment: Environment = {
    apiURL: 'https://signaturetours.com.ar',
    wordpressURL: 'https://blog.signaturetours.com.ar/wp-json/wp/v2',
};
